<template>
  <div class="bg-grey-100">
    <nav
      class="flex items-center justify-between flex-wrap bg-white border-b border-grey-300 flex-row-reverse md:flex-row relative"
    >
      <NavbarLogo
        :navLogo="navLogo"
        :isPreview="isPreview"
        :membershipOutline="membershipOutline"
        :changePage="changePage"
      />
      <NavbarProfileSettings
        :user="user"
        :isPreview="isPreview"
        :logout="logout"
        :profile="profile"
        :backPortalPage="backPortalPage"
        :isPortal="isPortal"
      />
    </nav>
  </div>
</template>
<script>
import NavbarLogo from './navbar-logo.vue';
import NavbarProfileSettings from './navbar-profile-settings.vue';
export default {
  name: 'Navbar',
  props: [
    'navLogo',
    'user',
    'isPreview',
    'logout',
    'profile',
    'membershipOutline',
    'changePage',
    'backPortalPage',
    'isPortal',
  ],
  components: {
    NavbarLogo,
    NavbarProfileSettings,
  },
};
</script>
